var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DocAlertsConfigModalSetting from '@web/components/DocAlerts/DocAlertsConfigTab/DocAlertsConfigModalSetting';
import Button from '@web/components/layout/Button';
import Modal from '@web/components/layout/Modal';
import { useToast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
export var SingleDocAlertModal = function (_a) {
    var visible = _a.visible, onClose = _a.onClose, document = _a.document;
    var t = useTranslation().t;
    var toast = useToast().toast;
    var createDocumentAlertConfigMutation = trpc.createDocumentAlertConfig.useMutation();
    var onSuccess = function () {
        toast({
            title: t('docAlerts.docAlertsConfig.createDocAlertSuccess'),
            variant: 'success',
            duration: 3000
        });
        onClose();
    };
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var _search, alertValues;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _search = values.search, alertValues = __rest(values, ["search"]);
                    return [4 /*yield*/, createDocumentAlertConfigMutation.mutateAsync(__assign(__assign({}, alertValues), { createDocumentIds: [document.id] }), {
                            onSuccess: function () { return onSuccess(); }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var initialValues = {
        isEdited: true,
        isCopy: true,
        isDownload: true,
        isSendToEmail: true,
        isShareAnyone: true,
        isShareExternally: true,
        isShareViaLink: true,
        isRequestAccess: true,
        isPrint: true,
        isDeleteTrash: true,
        isRenameMove: true,
        isPublish: true,
        except: null,
        search: ''
    };
    return (_jsx(Modal, __assign({ visible: visible, onClose: onClose }, { children: _jsx(Formik, __assign({ initialValues: initialValues, onSubmit: onSubmit }, { children: function (_a) {
                var values = _a.values, handleSubmit = _a.handleSubmit, handleChange = _a.handleChange;
                return (_jsx(Form, __assign({ onSubmit: handleSubmit }, { children: _jsxs("div", __assign({ className: "p-6" }, { children: [_jsx("h2", __assign({ className: "text-xl text-center font-semibold mb-1" }, { children: t('docAlerts.modal.createDocumentAlert') })), _jsx("p", __assign({ className: "text-gray-500 text-sm font-medium leading-7 text-center mb-4 truncate" }, { children: document.title })), _jsx(DocAlertsConfigModalSetting, { values: values, handleChange: handleChange }), _jsx("div", __assign({ className: "flex justify-end" }, { children: _jsxs("div", __assign({ className: "flex mt-5" }, { children: [_jsx(Button, __assign({ variant: "white", type: "button", className: "mr-5", onClick: onClose }, { children: t('button.cancel') })), _jsx(Button, __assign({ variant: "primary", type: "submit" }, { children: t('button.save') }))] })) }))] })) })));
            } })) })));
};
export default SingleDocAlertModal;
